import { useApolloClient } from '@apollo/client';
import { Button, message } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type AuthorizationProps } from '.';
import {
    CreateAudiFinancingAuthorizationDocument,
    type CreateAudiFinancingAuthorizationMutation,
    type CreateAudiFinancingAuthorizationMutationVariables,
} from '../../../../../api/mutations/createAudiFinancingAuthorization';
import NoItemResult from '../../../../../components/results/NoItemResult';

const AuthorizationEmpty = ({ module }: AuthorizationProps) => {
    const { t } = useTranslation(['audiFinancingModuleDetails']);
    const apolloClient = useApolloClient();
    const createAuthorization = useCallback(async () => {
        message.loading({
            content: t('audiFinancingModuleDetails:messages.creatingAuthorization'),
            key: 'primary',
            duration: 0,
        });

        await apolloClient.mutate<
            CreateAudiFinancingAuthorizationMutation,
            CreateAudiFinancingAuthorizationMutationVariables
        >({
            mutation: CreateAudiFinancingAuthorizationDocument,
            variables: {
                moduleId: module.id,
            },
        });

        message.success({
            content: t('audiFinancingModuleDetails:messages.createAuthorization'),
            key: 'primary',
        });
    }, [apolloClient, module.id, t]);

    return (
        <NoItemResult
            extra={
                <Button onClick={createAuthorization} type="primary">
                    {t('audiFinancingModuleDetails:actions.createSDMAuthorization')}
                </Button>
            }
            subTitle={t('audiFinancingModuleDetails:tabs.authorization.noData')}
        />
    );
};

export default AuthorizationEmpty;
